import { createFileRoute } from '@tanstack/react-router';
import { createSheetRouteOptions } from '@/components/molecules/sheet-view-loader/route-helpers';
import { PROTECTED, SERVICE_CONTRACTS } from '@/lib/constants/routes';
import { ServiceContractSheet } from '@/pages/service-contracts/detail/service-contract-sheet';

const RETURN_URL = `${PROTECTED}${SERVICE_CONTRACTS}`;

export const Route = createFileRoute(
  '/protected/_layout/service-contracts/_layout/$id'
)({
  ...createSheetRouteOptions(RETURN_URL),
  component: ServiceContractRoute,
});

function ServiceContractRoute() {
  const { id } = Route.useParams();
  return <ServiceContractSheet id={id} returnUrl={RETURN_URL} />;
}
